import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, Languages, ServiceStatus, TransitConfirmVesselEntranceDecision, TransitRequestWFSteps } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { Router } from '@angular/router';
import { TransitIssueResolutionComponent } from 'src/app/front-user/services/e-booking/transit-issue-resolution/transit-issue-resolution.component';
import { AgentApprovalLimittimeRateComponent } from '../Agent-Approval-Limit-time-Rate/Agent-Approval-Limit-time-Rate.component';

@Component({
  selector: 'app-confirm-vessel-entrance',
  templateUrl: './confirm-vessel-entrance.component.html'
})
export class ConfirmVesselEntranceComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitRequestWFSteps.ConfirmVesselEntrance;
  confirmVesselEntranceForm: FormGroup;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  decision = TransitConfirmVesselEntranceDecision;
  decisionKeys = Object.keys(this.decision);
  decisionValue: number;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest;
  displayedLang: string;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  isLoaded: boolean = false;
  @ViewChild('TransitRequest', { static: false }) TransitRequest: TransitRequestComponent;
  @ViewChild('TransitIssueResolution', { static: false }) TransitIssueResolution: TransitIssueResolutionComponent;
  @ViewChild('LimitTimeAcceptance', { static: false }) LimitTimeAcceptance: AgentApprovalLimittimeRateComponent;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  stepHistoryId: any;
  stepData: any;
  navigationNotes: string = '';
  showNavigationNotes: boolean = false;
  latestStepId: number;
  showLimitTimeAcceptance: boolean = false;
  showTransitRequest: boolean = true;
  showTransitIssueResolution: boolean = false;
  isPaid: boolean = false;
  alert: boolean = false;
  transitDate: Date; // Add this property to store transit date
  requestStatuses: number[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private router: Router,
  ) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {
    this.confirmVesselEntranceForm = this.formBuilder.group({
      Decision: ['', Validators.required],
    });
    if (decision == TransitConfirmVesselEntranceDecision.CANCEL_TRANSIT) {
      this.confirmVesselEntranceForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Reason: ['', Validators.required],
      });
    } else if (decision == TransitConfirmVesselEntranceDecision.SEND_TO_NAVIGATION) {
      this.confirmVesselEntranceForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Notes: ['', Validators.required],
      });
    } else if (decision == TransitConfirmVesselEntranceDecision.CONFIRM_TRANSIT) {
      this.confirmVesselEntranceForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        ConvoyDate: [this.transitDate, Validators.required], // Add ConvoyDate with default transit date
      });
    }
  }

  changeDecision(value) {
    this.buildForm(value);
    this.confirmVesselEntranceForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
    if (this.decisionValue == TransitConfirmVesselEntranceDecision.CONFIRM_TRANSIT && !this.isPaid) {
      this.alert = true;
    }
    else {
      this.alert = false;
    }
  }

  get f() { return this.confirmVesselEntranceForm.controls; }

  receiveLatestStepId(event) {
    if (event === undefined) return;
    this.latestStepId = event;
    this.handleLatestStep();
  }

  handleLatestStep() {
    if (!this.latestStepId) return;

    this.isLoaded = true;

    if (this.latestStepId === TransitRequestWFSteps.NavigationDecision) {
      this.getNavigationDecisionData();

    } else if (this.latestStepId === TransitRequestWFSteps.TransitIssueResolution) {
      this.showTransitIssueResolution = true;
      this.showTransitRequest = false;

    } else if (this.latestStepId === TransitRequestWFSteps.LimitTimeAcceptance) {
      this.showLimitTimeAcceptance = true;
      this.showTransitRequest = false;
    }
  }
  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistoryById();
        } else if (!this.requestStatuses.includes(ServiceStatus.Transit_PendingConfirmVesselEntrance)) {
          this.formMode = FormMode.Readonly;
          this.getTransitRequest();
          this.getTransitRequestWFHistory();
        } else if (this.requestStatuses.includes(ServiceStatus.Transit_PendingConfirmVesselEntrance)) { // New Mode But comming from other path
          this.formMode = FormMode.Add;
          this.getTransitRequest();
          // this.latestStepId = this.TransitRequest.transitRequest.LatestStepId;
          if (this.latestStepId) {
            this.handleLatestStep();
          }
        }
      }
    )
  }
  public getTransitRequest() {
    this.transitService.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.isPaid = this.responseObj.Data['IsEstimatedFeesPaid'];
          // Get transit date from response
          if (this.responseObj.Data['AgentTransitDate']) {
            this.transitDate = this.responseObj.Data['AgentTransitDate'];
          }
        }
      });
  }

  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, this.stepId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }

    );
  }

  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }

    );
  }

  getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.decisionValue = this.stepData.Decision;
    this.changeDecision(this.decisionValue);
    if (this.decisionValue == TransitConfirmVesselEntranceDecision.CANCEL_TRANSIT) {
      this.confirmVesselEntranceForm.patchValue({
        Reason: this.stepData.Reason
      });
    } else if (this.decisionValue == TransitConfirmVesselEntranceDecision.SEND_TO_NAVIGATION) {
      this.confirmVesselEntranceForm.patchValue({
        Notes: this.stepData.Notes
      });
    } else if (this.decisionValue == TransitConfirmVesselEntranceDecision.CONFIRM_TRANSIT) {
      this.confirmVesselEntranceForm.patchValue({
        ConvoyDate: this.stepData.ConvoyDate ? new Date(this.stepData.ConvoyDate) : this.transitDate
      });
    }

    this.confirmVesselEntranceForm.disable();
  }

  getNavigationDecisionData() {
    // Get Step Data of Navigation Decision
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, TransitRequestWFSteps.NavigationDecision).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          if (!this.stepData) return;
          this.navigationNotes = this.stepData.NavigationNotes;
          this.showNavigationNotes = true;
        }
      }
    );
  }


  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.confirmVesselEntranceForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.IsVesselTransited = this.confirmVesselEntranceForm.controls['Decision'].value == TransitConfirmVesselEntranceDecision.CONFIRM_TRANSIT ? true : false;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.confirmVesselEntranceForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.TransitRequest?.feesRequest?.feesDetailsForm.get('DirectionId')?.value
      ?? this.TransitIssueResolution?.TransitRequest?.feesRequest?.feesDetailsForm.get('DirectionId')?.value
      ?? this.LimitTimeAcceptance?.transitRequest?.feesRequest?.feesDetailsForm.get('DirectionId')?.value;
    if (this.decisionValue == TransitConfirmVesselEntranceDecision.CONFIRM_TRANSIT) {
      this.transitRequestCustomObj.ConvoyDate = this.confirmVesselEntranceForm.controls['ConvoyDate'].value;
    }


    this.transitService.SubmitConfirmVesselEntranceDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.confirmVesselEntranceForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
